<ng-diversions-complete
  *ngIf="(store$ | async) as store"
  [loading]="store.isLoadingComplete"
  (completeDiversion)="complete($event)">
</ng-diversions-complete>
